<section class="about_section">
    <div class="about__container containerPersonal">
        <div class="about__data">
            <h1 class="home__title">Contacto</h1>
            
            <div class="contact__options">
                <!-- Opción de formulario -->
                <div class="contact__form-section">
                    <h3 class="home__subtitle">¡Trabajemos juntos!</h3>
                    <form id="contact-form" action="https://api.web3forms.com/submit" method="POST">
                        <input placeholder="Nombre completo" type="text" name="name" required="">
                        <input type="hidden" name="subject" value="Consulta desde Corvus TID Website">
                        <input type="hidden" name="access_key" value="8914c565-af94-467f-aa60-2312bfad8047">
                        <input placeholder="Correo electrónico" type="email" name="email" required="">
                        <input placeholder="Empresa/Organización" type="text" name="company">
                        <textarea placeholder="Cuéntanos sobre tu proyecto" type="text" name="message" required=""></textarea>
                        
                        <div id="success">
                            <div>
                                Tu mensaje fue enviado exitosamente. ¡Gracias por contactarnos!<span id="close" class="mdi mdi-close"></span>
                            </div>
                        </div>
                        <input class="button" type="submit" id="submit" value="ENVIAR CONSULTA">
                        
                    </form>
                </div>

                <!-- Separador visual -->
                <div class="contact__separator">
                    <span>o</span>
                </div>

                <!-- Opción de contacto directo -->
                <div class="contact__direct">
                    <h3 class="direct__title">Contacto Directo</h3>
                    <p class="direct__description">
                        ¿Prefieres escribirnos directamente?
                    </p>
                    <a href="mailto:info@corvustid.com" class="direct__email">
                        <span class="email__icon">📧</span>
                        <span class="email__text">info@corvustid.com</span>
                    </a>
                    <p class="direct__note">
                        Responderemos tu consulta en menos de 24 horas
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>